// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1MrW9","icon":"SortAdornment_icon__12WgC","up":"SortAdornment_up__2x9sL","down":"SortAdornment_down__dYFkF","active":"SortAdornment_active__PossC"};